import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { useTablePDFDownload } from "../../utils/GenratePdfA4Table";

export default function ElectricityReport() {

    const [totalData, setTotalData] = useState([]);
    
    const invoiceRef = useRef(null);
    const downloadPDF = useTablePDFDownload(invoiceRef);

    const navigate = useNavigate();
    const handleNavigateToWaterUsage = () => {
        navigate('/water-usage');
    }
    const handleNavigateToElectricityUsage = () => {
        navigate('/electricity-usage');
    }

    // ====================================================>> Function
    const togglePrint = () => {
        window.print();
    }

    // ======================================================>> Fetching API
    const totalElectricity = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/electricity/total`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch total electricity data.');
            }

            const data = await response.json();
            setTotalData(data);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        totalElectricity();
    }, []);
    let firstSlideData;
    let secondSlideData;
    let lastSlideData;
    if (Array.isArray(totalData)) { 
        firstSlideData = totalData.slice(0, 4);  
        secondSlideData = totalData.slice(4,8);   
        lastSlideData = totalData.slice(8);
    }

    return (
        <div className="w-full h-[100dvh] bg-white">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-white">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-white">ការប្រើប្រាស់ភ្លើងតាមអគារ</h2>
                </div>
            </div>
            {/* Done Header */}

            {/* Body */}
            {/* Buttons */}
            <div className="flex flex-col md:flex-row pt-5 md:px-12 items-center md:items-stretch justify-between">
                <div className="flex  space-x-4 md:mr-auto mb-3 md:mb-0">
                    <button className="bg-secondary1 rounded-xl text-white py-2 px-10 md:px-8 text-lg" onClick={handleNavigateToWaterUsage}>+ បញ្ចូលទឹក</button>
                    <button className="bg-secondary1 rounded-xl text-white py-2 px-10 md:px-8 text-lg" onClick={handleNavigateToElectricityUsage}>+ បញ្ចូលភ្លើង</button>
                </div>
                <div className="flex">
                    {/* <button className="bg-white border-2 hover:border px-10 py-1 sm:py-2 lg:py-2 rounded-3xl text-blue-700 flex text-xl sm:text-base lg:text-lg items-center mr-3 shadow-sm" onClick={downloadPDF}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="blue" className="size-5 mr-1">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
                        </svg> 
                        <span className="hidden lg:flex">Print</span>
                    </button> */}
                    <button onClick={downloadPDF} className="h-14 bg-white font-medium text-black text-lg px-10 ml-5 rounded-lg duration-200 hover:bg-gray-100">↓ ទាញយក</button>
                    {/* <div className="bg-gray-300 rounded-lg">
                        {/* <button className="rounded-xl text-black py-2 px-12 text-lg">ទឹក</button> */}
                        {/* <button className="bg-primary1 rounded-xl text-white py-2 px-12 text-lg">ភ្លើង</button>
                    </div> */}
                </div>
            </div>

            {totalData ? 
            (
                <div className="flex flex-col md:flex-row w-full md:space-x-5 space-y-5 md:space-y-0 pb-5 md:pb-0 justify-center mt-5 md:mt-14 pl-4 md:pl-0" ref={invoiceRef}>
                {/* First column */}
                <div className="w-full md:w-[30%] space-y-8">
                    {firstSlideData.map((data, index) => (
                        <div className="flex text-2xl space-x-5 items-center">
                            <p className="font-medium">អគារ <span className="font-semibold">{data.building}</span></p>
                            <div className="bg-white py-2 px-4 md:px-4 md:py-3 rounded-md shadow-custom-shadow w-[60%] font- md:text-lg lg:text-2xl border-2 text-end">{parseInt(data.total).toLocaleString()} R</div>
                        </div>
                    ))}
                </div>
                {/* Second column */}
                <div className="w-full md:w-[30%] space-y-8">
                    {secondSlideData.map((data, index) => (
                        <div className="flex text-2xl space-x-5 items-center">
                            <p className="font-medium">អគារ <span className="font-semibold">{data.building}</span></p>
                            <div className="bg-white py-2 px-4 md:px-4 md:py-3 rounded-md shadow-custom-shadow w-[60%] font-normal md:text-lg lg:text-2xl border-2 text-end">{parseInt(data.total).toLocaleString()} R</div>
                        </div>
                    ))}
                </div>
                {/* Third column */}
                <div className="w-full md:w-[30%] space-y-8">
                    {lastSlideData.map((data, index) => (
                        <div className="flex text-2xl space-x-5 items-center">
                            <p className="font-medium">អគារ <span className="font-semibold">{data.building}</span></p>
                            <div className="bg-white py-2 px-4 md:px-4 md:py-3 rounded-md shadow-custom-shadow w-[60%] font-normal md:text-lg lg:text-2xl border-2 text-end">{parseInt(data.total).toLocaleString()} R</div>
                        </div>
                    ))}
                </div>
            </div>
            )
            :(<div className="flex w-full space-x-5 justify-center mt-14 text-lg">
                Loading ...
            </div>)
            }
        </div>
    )
}